import { AvatarSize, AvatarIconSize } from "./types";

export const getAvatarIconSize = (size: AvatarSize) => {
  return AVATAR_SIZE_TO_ICON_SIZE_MAP[size];
};

const AVATAR_SIZE_TO_ICON_SIZE_MAP: { [key in AvatarSize]: AvatarIconSize } = {
  xxSmall: "small",
  xSmall: "small",
  small: "medium",
  medium: "medium",
  large: "medium",
  xLarge: "large",
};
